export const PASSWORD =
{
  NOT_EQUAL: 'Las contraseñas no coinciden',
  EQUAL: 'Las contraseñas coinciden',
  CAPITAL_LETTER: 'La contraseña debe incluir una mayúscula.',
  NUMBER: 'La contraseña debe incluir al menos un número.',
  MIN: 'La contraseña debe incluir 8 o más caracteres.',
  LOWERCASE: 'La contraseña debe incluir una minúscula como mínimo.'
}
